export const selectEmployees = (state) =>
  state.companyEmployee?.employees || [];
export const selectEmployeeLoading = (state) =>
  state.companyEmployee?.loading || false;
export const selectEmployeeError = (state) =>
  state.companyEmployee?.error || null;
export const selectSelectedEmployee = (state) =>
  state.companyEmployee?.selectedEmployee || null;
